<!--
    描述：考核系统 --- 公用 表格主体
    时间：2021-03-10
    Created by 王帅
    updated by 钱磊 2022-5-18 11:05:04
-->
<template>
    <div class="common-layout">
        <div class="info-nav">
            <span
                >考核对象：<i class="color-blue">{{ textInfo.markObjName }}</i></span
            >
            <el-divider class="divider" direction="vertical"></el-divider>
            <span
                >考核人角色：<i class="color-blue">{{ textInfo.judgeRoleName }}</i></span
            >
            <el-divider class="divider" direction="vertical"></el-divider>
            <span
                >被考核人角色：<i class="color-blue">{{
                    textInfo.beJudgeRoleName
                }}</i></span
            >

            <!-- <span>合计单项满分值: {{  }}</span> -->
        </div>
        <!-- 选择列表 -->
        <vxe-table
            ref="tableObj"
            :data="tableObj.tableData"
            :loading="tableObj.loading"
            :border="tableObj.border"
            :resizable="tableObj.resizable"
            :size="tableObj.size"
            :height="tableObj.height"
            highlight-current-row
            highlight-hover-row
            auto-resize
            show-overflow="tooltip"
            show-header-overflow="tooltip"
            :edit-config="{ trigger: 'dblclick', mode: 'cell' }"
            @edit-closed="onEditClosed"
            :span-method="mergeRowMethod"
        >
            <vxe-table-column
                v-if="module === 'select'"
                type="checkbox"
                width="60"
                align="center"
            ></vxe-table-column>
            <vxe-table-column
                type="seq"
                title="序号"
                width="60"
                align="center"
            ></vxe-table-column>
            <vxe-table-column
                v-for="(item, index) in activeColumns"
                :key="item.prop + index"
                :field="item.prop"
                :title="item.title"
                :min-width="item.minWidth"
                :width="item.width"
                :align="item.align"
                :header-align="item.headerAlign"
                :edit-render="item.editRender"
            >
                <template v-slot="{ row }">
                    <!-- 如果需要渲染 -->
                    <span v-if="item.needRender">{{
                        item.function(row[item.prop])
                    }}</span>

                    <!-- 如果是 单项满分值 -->
                    <vxe-input
                        v-else-if="item.prop === 'singleScore' && tableObj.viewMode"
                        type="number"
                        :disabled="tableObj.showMode"
                        v-model="row.singleScore"
                    ></vxe-input>

                    <!-- 如果是 备注 -->
                    <vxe-input
                        v-else-if="item.prop === 'remark' && tableObj.viewMode"
                        :disabled="tableObj.showMode"
                        v-model="row.remark"
                        maxlength="50"
                        show-word-count
                        placeholder="请输入考核注意事项，不超过50个字"
                    ></vxe-input>

                    <!-- 如果是 考核 -->
                    <vxe-input
                        v-else-if="item.prop === 'score'"
                        type="number"
                        :disabled="tableObj.showMode"
                        v-model.number="row.score"
                    ></vxe-input>

                    <!-- 如果是 评语 -->
                    <vxe-input
                        v-else-if="item.prop === 'comment'"
                        :disabled="tableObj.showMode"
                        v-model="row.comment"
                        maxlength="50"
                        show-word-count
                        placeholder="请输入评语，不超过50个字"
                    ></vxe-input>

                    <span v-else>{{ row[item.prop] }}</span>
                </template>
            </vxe-table-column>
        </vxe-table>

        <el-row class="mt20 setting-text">
            <el-col :span="20">
                <p class="show-total">总分： {{ totalScore }}分</p>
                <p>
                    合计考核：<span class="text-border color-blue">{{ sumTotal }}分</span>
                    考核结果：<span class="text-border"> </span>
                </p>
                <p>{{ resultText }}</p>
            </el-col>
            <el-col :span="4" class="text-right">
                <!-- <el-button class="btn-blue">修改考核规则</el-button> -->
                <el-button class="btn-blue" @click="doSubmit">提交</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: {
        // 模块
        module: {
            type: String,
            default: "",
        },
        // 文字信息
        textInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
        // 表格对象
        tableObj: {
            type: Object,
            default: () => {
                return {
                    tableData: [],
                    loading: false,
                    border: true,
                    resizable: true,
                    size: "small",
                    height: "100%",
                    setting: false, // 开始设置
                    showMode: false, // 展示模式
                    canSave: false, // 可以保存
                };
            },
        },
        // 列对象
        activeColumns: {
            type: Array,
            default: () => {
                return [];
            },
        },
        // 是否需要合并
        needMerge: {
            type: Boolean,
            default: false,
        },
        // 总分
        totalScore: {
            type: Number,
            default: 100,
        },
        // 结果数组
        markResult: {
            type: Array,
            default: () => {
                return [
                    {
                        type: 0, // 0.差评 1.良好 2.优秀 3.完美
                        min: 0,
                        max: 60,
                        title: "差评",
                    },
                    {
                        type: 1, // 0.差评 1.良好 2.优秀 3.完美
                        min: 61,
                        max: 80,
                        title: "良好",
                    },
                    {
                        type: 2, // 0.差评 1.良好 2.优秀 3.完美
                        min: 81,
                        max: 95,
                        title: "优秀",
                    },
                    {
                        type: 3, // 0.差评 1.良好 2.优秀 3.完美
                        min: 96,
                        max: 100,
                        title: "完美",
                    },
                ];
            },
        },
    },
    data() {
        return {};
    },
    methods: {
        // 编辑类别
        onEditClosed({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {
            this.$emit("editClosed", {
                row,
                rowIndex,
                $rowIndex,
                column,
                columnIndex,
                $columnIndex,
            });
        },

        // 通用行合并函数（将相同多列数据合并为一行）
        mergeRowMethod({ row, _rowIndex, column, visibleData }) {
            // 如果不需要合并
            if (!this.needMerge) {
                return;
            }
            // 定义要合并的 列 属性数组
            const fields = ["typeName"];
            const compareField = "itemType";
            const typeValue = row[compareField];
            // 如果是 合并的那列 且 要比较的值有数据
            if (typeValue && fields.includes(column.property)) {
                // 上一行
                const prevRow = visibleData[_rowIndex - 1];
                // 下一行
                let nextRow = visibleData[_rowIndex + 1];

                // 如果上一行存在 且 数据和当前行相同
                if (prevRow && prevRow[compareField] === typeValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow[compareField] === typeValue) {
                        nextRow = visibleData[++countRowspan + _rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            }
        },

        // 点击提交
        doSubmit() {
            let params = {
                totalScore: this.sumTotal,
            };
            this.$emit("onSaveRecords", params);
        },
    },
    computed: {
        // 考核结果 文案
        resultText() {
            let str = "提示：考核结果 ";
            this.markResult.map((x) => {
                str = str + `${x.min}-${x.max}分 为${x.title}, `;
            });
            str = str.slice(0, str.length - 2);
            return str;
        },

        // 输入的分数合计
        sumTotal() {
            let arr = this.tableObj.tableData.map((x) => parseFloat(x.score));
            return arr.sum();
        },
    },
};
</script>

<style scoped lang="less">
.common-layout {
    height: 100%;
    .color-blue {
        color: #256fc8;
        font-style: normal;
    }

    .info-nav {
        line-height: 40px;
        color: #202020;
        font-size: 14px;
        // border-bottom: 1px solid #2671cc;

        .info-title {
            font-size: 16px;
            margin-right: 20px;
        }

        .divider {
            background-color: #202020;
            vertical-align: text-top;
        }
    }

    .min-height {
        min-height: 500px;
    }

    .text-border {
        margin-right: 10px;
        border-bottom: 1px solid #666;
        font-size: 14px;
    }

    .setting-text {
        line-height: 35px;
        font-size: 14px;
    }
}
</style>
